<mat-form-field>
  <mat-label>
    {{ label }}
  </mat-label>
  <input
    type="text"
    matInput
    [formControl]="searchCtrl"
    [matAutocomplete]="plDropdownAutocomplete"
    (blur)="onBlur()"
  />
  <mat-autocomplete
    #plDropdownAutocomplete="matAutocomplete"
    (optionSelected)="optionSelected($event)"
  >
    <ng-content></ng-content>
    <mat-option
      *ngFor="let option of filteredOptions$ | async"
      [value]="option.value"
    >
      {{ option.label }}
    </mat-option>
  </mat-autocomplete>
  <button
    type="button"
    matSuffix
    mat-icon-button
    (click)="searchCtrl.value && clear()"
  >
    <mat-icon>{{ searchCtrl.value ? 'close' : 'arrow_drop_down' }}</mat-icon>
  </button>
</mat-form-field>
